import { cn } from '../lib/cn';

/**
 * Licznik w zakładkach i nagłówkach (lifting 17.10.2026, DESIGN „Lifting 17.10.2026”): mała pigułka z liczbą
 * (np. „Do zrobienia ⟨4⟩”, „Zadania ⟨6⟩”). `neutral` — szare tło `soft`, `accent` — coś do zrobienia (akcent).
 * W menu bocznym zostaje `Badge` (wzorzec Nav item z Figmy).
 *
 * Liczba jest tekstem (czytniki ekranu przeczytają ją razem z etykietą: „Do zrobienia 4”); `label` dodaje
 * dopowiedzenie tylko dla czytników (np. „4 zadania”).
 */
export function CountPill({
  count,
  tone = 'neutral',
  label,
  className,
}: {
  count: number;
  tone?: 'neutral' | 'accent';
  /** pełny opis liczby dla czytników ekranu (wtedy sama liczba jest ukryta przed nimi) */
  label?: string;
  className?: string;
}) {
  const text = count > 999 ? '999+' : String(count);
  return (
    <span
      data-count-pill=""
      className={cn(
        'inline-flex h-[18px] min-w-[18px] shrink-0 items-center justify-center rounded-full px-1.5',
        'text-micro font-medium tabular',
        tone === 'accent' ? 'bg-accent-subtle text-accent' : 'bg-soft text-fg-secondary',
        className,
      )}
    >
      {label ? (
        <>
          <span aria-hidden>{text}</span>
          <span className="sr-only">{label}</span>
        </>
      ) : (
        text
      )}
    </span>
  );
}
